// extracted by mini-css-extract-plugin
export var background = "bJ_y";
export var backgroundContainer = "bJ_fx";
export var bottomWave = "bJ_cW";
export var buttons = "bJ_cp";
export var container = "bJ_h";
export var content = "bJ_cf";
export var icon = "bJ_bw";
export var iconContainer = "bJ_bX";
export var middleWave = "bJ_cV";
export var negativeTop = "bJ_gQ";
export var overlap = "bJ_gS";
export var section = "bJ_j";
export var selected = "bJ_bg";
export var tab = "bJ_dV";
export var tabText = "bJ_dT";
export var title = "bJ_d";
export var topWave = "bJ_gR";